import React from 'react';
import PropTypes from 'prop-types';
import SubmitModal from '../shared/SubmitModal';
import { Container, Row, Col } from 'react-bootstrap';
import DateHelper from '../../helpers/DateHelper';

const UserEmails = ({
    user,
    secondaryEmail,
    onOpenModal,
    onCloseModal,
    onRemove,
    modals,
    onSave,
    onChange,
    isValid,
    localized
}) => {
    return (
        <div className="subemail flex" style={{ flexDirection: 'row', gap: '2rem' }}>
            {/* Primary Email */}
            <div className="email-section">
                <div className="label text">{localized.Primary}</div>
                <div className="email">{user.email}</div>
            </div>

            {/* Secondary Email */}
            <div className="email-section">
                <div className="label text">{localized.Secondary}</div>
                <div className="email">{user.secondaryEmail || '—'}</div>
                <div className="button-row" style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem' }}>
                    <button className="button link" onClick={onOpenModal}>
                        {user.secondaryEmail ? localized.Edit : localized.Add} {localized.SecondaryEmail}
                    </button>
                    {user.secondaryEmail && (
                        <div className="button-wrapper">
                    <button className="remove" onClick={onRemove}>
                      <span>X </span><span>{localized.Remove}</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Last Login */}
            <div className="email-section">
                <div className="label text">{localized.LastLogin}</div>
                <div className="email">
                    {user.lastActivity
                        ? DateHelper.format(new Date(user.lastActivity), 'MM/dd/yyyy hh:mm a', true)
                        : '—'}
                </div>
            </div>

            {/* Modal for Secondary Email */}
            <SubmitModal
                isOpen={modals.secondaryEmail}
                onSubmit={onSave}
                onClose={onCloseModal}
                submitText={localized.Save}
                closeText={localized.Cancel}
            >
                <Container>
                    <Row>
                        <Col xs={8}>
                            <div className="heading2" style={{ paddingBottom: '1.2rem' }}>
                                {user.secondaryEmail ? localized.Edit : localized.Add} {localized.SecondaryEmail}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={1}></Col>
                        <Col xs={6} md={10}>
                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    className="input-secondary-email"
                                    onChange={onChange}
                                    value={secondaryEmail || ''}
                                />
                            </div>
                        </Col>
                    </Row>
                    {!isValid && (
                        <Row>
                            <Col xs={1}></Col>
                            <Col xs={8}>
                                <div className="invalid-email-message">
                                    {localized.InvalidEmailMessage}
                                </div>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <div style={{ color: '#848484', fontWeight: '500', lineHeight: '21px' }}>
                            {localized.Body}
                        </div>
                    </Row>
                </Container>
            </SubmitModal>
        </div>
    );
};

UserEmails.propTypes = {
    user: PropTypes.object.isRequired,
    secondaryEmail: PropTypes.string.isRequired,
    onOpenModal: PropTypes.func.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    modals: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
    localized: PropTypes.object.isRequired
};

export default UserEmails;
